import FullScreenCardPage from "./FullScreenCardPage";
import { RemoteSlideProps, Slide } from "./types";
import ShareToStory from "src/shared/components/ShareToStory";

export const ShareToStorySlide = (
  defaultCopy: string,
  displayCopy: string,
  imageUrl: string,
  displaySubCopy?: string,
): Slide => {
  return {
    remote: (props: RemoteSlideProps) => <ShareToStory imageUrl={imageUrl} defaultCopy={defaultCopy} {...props} />,
    display: () => (
      <FullScreenCardPage>
        <div sx={{ fontSize: "48px", fontWeight: 800, padding: "dt_xl", textAlign: "center" }}>
          {displayCopy}
          {displaySubCopy && <p>{displaySubCopy}</p>}
        </div>
      </FullScreenCardPage>
    ),
  };
};
